import { queryOptions } from "@tanstack/react-query";
import { Map } from "immutable";
import { Person } from "@/interfaces/person";

export const voiceIdPersonMapOptions = () => {
  return queryOptions<
    Map<number, Person>,
    Error,
    Map<number, Person>,
    [string]
  >({
    queryKey: ["voices"],
    queryFn: () => Map(),
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled: false,
  });
};
